import { useEffect } from "react";
import { withRouter } from "react-router";

const Component = ({ history }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      console.log("Scrolling up");
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, []);

  return null;
};

export const ScrollToTopRouteWatcher = withRouter(Component);
